import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './AdminRoute.css';

const AdminRoute = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(null); // null = checking, true = admin, false = not admin
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminAccess = async () => {
      try {
        // Try to access admin endpoint - if it works, user is admin
        await api.get('/api/admin/users?page=1&limit=1');
        setIsAdmin(true);
      } catch (error) {
        // Check if it's a password error (user IS admin, just needs password)
        if (error.response?.status === 403 && error.response?.data?.error === 'Admin password required') {
          // User is admin, just needs password - allow access (AdminPanel will handle password)
          setIsAdmin(true);
        } else {
          // Any other error (403 with different message, etc.) means not admin
          setIsAdmin(false);
        }
      } finally {
        setLoading(false);
      }
    };
    
    checkAdminAccess();
  }, []);

  // Show nothing while checking (prevents flash of admin panel)
  if (loading || isAdmin === null) {
    return null;
  }

  // If not admin, show 404 (route doesn't exist)
  if (!isAdmin) {
    return (
      <div className="not-found-container">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-subtitle">Page Not Found</p>
        <p className="not-found-message">Much sad, very lost</p>
      </div>
    );
  }

  // If admin, render the children (AdminPanel)
  return children;
};

export default AdminRoute;

